export enum PaymentMethod {
    Card = 1,
    Invoice = 2,
    Wallet = 3,
}
